import requestBuilder from '@/requestBuilder'

const apiFiles = {
  postFileUpload (body) {
    return requestBuilder.post({ path: `/files`, body })
  },
  putFileStatus (fileId) {
    return requestBuilder.put({ path: `/files/${fileId}/status` })
  },
  getFileDownload (fileId) {
    return requestBuilder.get({ path: `/files/${fileId}/download` })
  },
  postFileShare (fileId) {
    return requestBuilder.post({ path: `/files/${fileId}/share` })
  },
  putUpdateFileRequest (fileId, body) {
    return requestBuilder.put({ path: `/files/${fileId}`, body })
  },
  moveFile ({ fileId, parentItemId }) {
    return requestBuilder.put({ path: `/files/${fileId}/move/${parentItemId}` })
  },
  deleteFile (fileId) {
    return requestBuilder.delete({ path: `/files/${fileId}` })
  }
}

export default apiFiles
